// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e40b446f","453":"480339c3"}[chunkId] + ".chunk.js";
};